import 'flatpickr/dist/flatpickr.css';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Routes
import { MainRoutingModule } from 'src/app/modules/main/main-routing.module';

// Modules
import { MainModule } from 'src/app/modules/main/main.module';

// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HeaderComponent } from './components/shared/header/header.component';
import { ShoppingCarComponent } from './components/shared/header/shopping-car/shopping-car.component';
import { EditShoppingCarComponent } from './components/shared/header/edit-shopping-car/edit-shopping-car.component';
import { MenuMobileComponent } from './components/shared/header/menu-mobile/menu-mobile.component';
import { MenuDesktopComponent } from './components/shared/header/menu-desktop/menu-desktop.component';


import { LoginComponent } from './components/shared/login/login.component';
import { LoginWithoutAddressComponent } from './components/shared/login-without-address/login-without-address.component';

import { OrderListComponent } from './components/shared/header/order-list/order-list.component';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { LoginUserInvitedComponent } from './components/shared/login-user-invited/login-user-invited.component';

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        ShoppingCarComponent,
        EditShoppingCarComponent,
        MenuMobileComponent,
        LoginComponent,
        LoginWithoutAddressComponent,
        OrderListComponent,
        MenuDesktopComponent,
        LoaderComponent,
        LoginUserInvitedComponent
    ],
    exports: [
        HeaderComponent,
        MenuMobileComponent,

    ],
    bootstrap: [AppComponent], imports: [
        ReactiveFormsModule,
        BrowserModule,
        MainRoutingModule,
        FormsModule,
        MainModule,
        BrowserAnimationsModule
        // AppRoutingModule
    ], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
